import { render, staticRenderFns } from "./cheka.vue?vue&type=template&id=0b7bc75d&scoped=true&"
import script from "./cheka.vue?vue&type=script&lang=js&"
export * from "./cheka.vue?vue&type=script&lang=js&"
import style0 from "./cheka.vue?vue&type=style&index=0&id=0b7bc75d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7bc75d",
  null
  
)

export default component.exports